import { render, staticRenderFns } from "./notMeetRequirements.vue?vue&type=template&id=10346da0&"
import script from "./notMeetRequirements.vue?vue&type=script&lang=js&"
export * from "./notMeetRequirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports